import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import en from './langs/en.json';
import jp from './langs/jp.json';


const resources = {
	en: {
		translation: en
	},
	jp: {
		translation: jp
	}
};


i18n
	.use(reactI18nextModule) // passes i18n down to react-i18next
	.use(detector)
	.init({
		resources,
		fallbackLng: 'jp',

		interpolation: {
			escapeValue: false
		}
	});
export default i18n;